import DetalleEmailTemplateContent from "./DetalleEmailTemplateContent";
import { useParams } from "react-router";

export const DetalleEmailTemplate = () => {
  const { id } = useParams();
  return (
    <div className="w-full flex flex-col max-h-[100%] overflow-hidden">
      <DetalleEmailTemplateContent templateId={id as string} />
    </div>
  );
};
